///
/// !!! 아래에 현재 프로바이더 관련 메세지 뿐아니라 앱 UI에 관련된 메세지도 포함되어있음
/// 수정필요
///

const Messages = {
  SET_SCROLL_INDEX_ADD: "set_scroll_index_add",
  SET_VIEW_POSITION_INITIALIZE: "set_view_position_initialize",
  // contrast
  CONTRAST_VIEWPORT: "contrast_viewport",
  CONTRAST_DEFAULT: "contrast_default",
  CONTRAST_FULL_DYNAMIC: "contrast_full_dynamic",
  RENDER_INVERT: "render_invert",
  ///
  /// Dialog 제어 메세지
  ///
  OPEN_MESSAGE_BOX: "open_message_box",
  OPEN_ABOUT_SOFTWARE_DIALOG: "open_about_software_dialog",
  OPEN_PREVIEW_DCM_DIALOG: "open_preview_dcm_dialog"
};

export default Messages;
